/**COMPNENT FOR SIZE START**/
const RenderSize = {
  props: {
    variants: String,
    mainproductid: String
  },
  data: function () {
    return {
      template: '' 
    }
  },
  mounted() {
    this.uf_render();
  },
  methods: {
    uf_render: function(index){
      let variants =  JSON.parse(this.variants);
      let phtml = '';
      let id = '';
      let title = '';
      let availableForSale = '';
      let price = '';

      
      for (var i = 0; i < variants.length; i++) {
        id = variants[i]['node']['id'];
        title = variants[i]['node']['title'];
        availableForSale = variants[i]['node']['availableForSale'];
        price = variants[i]['node']['price'];

        let arr_title = title.split('/');
        let size_text = arr_title[0].trim();
        let arr_size = size_text.split('-');
        if (arr_size[0].length <= 6) {
          if (availableForSale){
         phtml = phtml+`<span class="in_stock" title="In Stock" onclick="uf_addCart(`+id+`)">`+arr_size[0].trim()+`</span>`;
          }else{
          phtml = phtml+`<span class="out_of_stock" title="Out Of Stock">`+arr_size[0].trim()+`</span>`;
          }
        }
      
      }
      
      if (phtml!=''){
        phtml = `<div class="product_sizes product_size_`+this.mainproductid+`"><div class="product_size_header"><div class="q_svg"><svg fill="none" height="26" viewBox="0 0 24 26" width="24" xmlns="http://www.w3.org/2000/svg"><path d="M7.38636 7.63333C7.38636 8.04755 7.72215 8.38333 8.13636 8.38333C8.55058 8.38333 8.88636 8.04755 8.88636 7.63333H7.38636ZM15.1136 7.63333C15.1136 8.04755 15.4494 8.38333 15.8636 8.38333C16.2778 8.38333 16.6136 8.04755 16.6136 7.63333H15.1136ZM8.88636 7.63333V5.33333H7.38636V7.63333H8.88636ZM8.88636 5.33333C8.88636 4.81566 9.04911 4.02151 9.5161 3.378C9.95557 2.77241 10.6965 2.25 12 2.25V0.75C10.2126 0.75 9.0217 1.50537 8.30208 2.497C7.60998 3.45071 7.38636 4.57323 7.38636 5.33333H8.88636ZM12 2.25C13.3035 2.25 14.0444 2.77241 14.4839 3.378C14.9509 4.02151 15.1136 4.81566 15.1136 5.33333H16.6136C16.6136 4.57323 16.39 3.45071 15.6979 2.497C14.9783 1.50537 13.7874 0.75 12 0.75V2.25ZM15.1136 5.33333V7.63333H16.6136V5.33333H15.1136ZM19.7273 8.38333C19.7231 8.38333 19.7248 8.38309 19.7311 8.38396C19.737 8.38479 19.7444 8.38625 19.7521 8.38844C19.7598 8.39063 19.766 8.39299 19.7703 8.39498C19.7745 8.39695 19.7756 8.39791 19.7743 8.39695C19.7728 8.39587 19.7687 8.39272 19.7636 8.38701C19.7583 8.38108 19.7536 8.37423 19.7501 8.36745C19.7465 8.36061 19.7461 8.35747 19.7468 8.36045C19.7475 8.36369 19.75 8.37604 19.75 8.4H21.25C21.25 7.84639 21.0004 7.42939 20.6462 7.17639C20.3305 6.95091 19.9749 6.88333 19.7273 6.88333V8.38333ZM19.75 8.4V22.2H21.25V8.4H19.75ZM19.75 22.2C19.75 22.4621 19.6645 22.8729 19.4294 23.197C19.2217 23.4831 18.8671 23.75 18.1818 23.75V25.25C19.3511 25.25 20.1556 24.7502 20.6434 24.078C21.1037 23.4437 21.25 22.7045 21.25 22.2H19.75ZM18.1818 23.75H5.81818V25.25H18.1818V23.75ZM5.81818 23.75C5.55065 23.75 5.13358 23.6642 4.80527 23.4297C4.51551 23.2227 4.25 22.8731 4.25 22.2H2.75C2.75 23.3669 3.25721 24.1673 3.93336 24.6503C4.57097 25.1058 5.31299 25.25 5.81818 25.25V23.75ZM4.25 22.2V8.4H2.75V22.2H4.25ZM4.25 8.4C4.25 8.40496 4.24969 8.40413 4.25046 8.39867C4.25119 8.3935 4.25251 8.38691 4.25452 8.37994C4.25652 8.37301 4.25865 8.36757 4.26038 8.3639C4.26208 8.36027 4.26276 8.35967 4.26155 8.36133C4.26022 8.36317 4.25694 8.36726 4.2513 8.37221C4.24544 8.37735 4.23896 8.38172 4.23291 8.38482C4.22682 8.38794 4.22471 8.38795 4.22901 8.38697C4.23356 8.38593 4.24732 8.38333 4.27273 8.38333V6.88333C3.72168 6.88333 3.30352 7.12759 3.04754 7.48033C2.81908 7.79515 2.75 8.151 2.75 8.4H4.25ZM4.27273 8.38333H19.7273V6.88333H4.27273V8.38333Z" fill="black"></path></svg></div><div class="q_add">أضافة </div></div>`+phtml+`</div>`;
      }
      this.template = phtml;              
    }
  },        
  template: `<div class="size_container" v-html="this.template"></div>`
}
/**COMPNENT FOR SIZE END**/

/**COMPNENT FOR COLOR START**/
const RenderColor = {
  props: {
    metafields: String,
    mainproductid: String
  },
  data: function () {
    return {
      template: '',
      color_description: [["Deep Blue","#3e4071"],["Cashmere Rose","#ce879f"],["Jester Red","#751921"],["Dark Earth","#4d2e19"],["Turkish Coffee","#706f48"],["Rio Red","#751922"],["Peppercorn","#bfbdbb"],["Jet Black","#383E4E"],["Stone Grey","#939597"],["White Cloud","#EDEDE6"],["Leafy Khaki","#706F48"],["Sea Sage Green","#96A480"],["Natural Taupe","#AF9483"],["Sunset Red","#D1332C"],["Violet Blue","#464F75"],["Ocean Pale Blue","#9CC3DC"],["Pastel Lavendar","#B9B3D1"],["Pastel Pink","#F7C8C2"],["Cherry Red","#D1332C"],["Periwinkle Sky","#9cc3dc"],["Olive Green","#96a480"],["Feminine Pink","#c599c7"],["Warm Taupe","#af9483"]]    
    }
  },  
  mounted() {
    this.uf_render();
  },
  methods: {
    sortByKey: function (array, key) {
      return array.sort((a, b) => {
        let x = a[key];
        let y = b[key];

        return ((x < y) ? -1 : ((x > y) ? 1 : 0));
      });
    },   
    uf_render: function(index){
      let metafields = [];
      // try {
      //   metafields =  JSON.parse(this.metafields);
      // }
      // catch(err) {
      //   metafields = [];
      // }      
        metafields =  JSON.parse(this.metafields);

      
      let phtml = ''
      let pcolor = '';
      let phandle = '';
      let pkey = '';
      let pvalue = '';
      let ptitle = '';
      let p_artitle = '';
  
      for (var i = 0; i < metafields.length; i++) {
        pkey = metafields[i]['node']['key'];
        pvalue = metafields[i]['node']['value'].toLowerCase();

        if (pvalue.indexOf("#c599c7")>-1){
          metafields[i]['node']['sort_col']  = '19';
          metafields[i]['node']['arabic_title']  = 'الوردي المؤنث';
        }else if (pvalue.indexOf("#ce879f")>-1){
          metafields[i]['node']['sort_col']  = '18';
          metafields[i]['node']['arabic_title']  = 'روز الكشمير';
        }else if (pvalue.indexOf("#bfbdbb")>-1){
          metafields[i]['node']['sort_col']  = '17';
          metafields[i]['node']['arabic_title']  = 'حب الفلفل';
        }else if (pvalue.indexOf("#751922")>-1){
          metafields[i]['node']['sort_col']  = '16';
          metafields[i]['node']['arabic_title']  = 'ريو الأحمر';
        }else if (pvalue.indexOf("#706F48")>-1){
          metafields[i]['node']['sort_col']  = '15';
          metafields[i]['node']['arabic_title']  = 'قهوة تركية';
        }else if (pvalue.indexOf("#4d2e19")>-1){
          metafields[i]['node']['sort_col']  = '14';
          metafields[i]['node']['arabic_title']  = 'أرض مظلمة';
        }else if (pvalue.indexOf("#751921")>-1){
          metafields[i]['node']['sort_col']  = '13';
          metafields[i]['node']['arabic_title']  = 'المهرج الأحمر';
        }else if (pvalue.indexOf("#3e4071")>-1){
          metafields[i]['node']['sort_col']  = '12';
          metafields[i]['node']['arabic_title']  = 'ازرق غامق';
        }else if (pvalue.indexOf("#383e4e")>-1){
          metafields[i]['node']['sort_col']  = '11';
          metafields[i]['node']['arabic_title']  = 'أسود فحمي - أسود';
        }else if(pvalue.indexOf("#939597")>-1){
          metafields[i]['node']['sort_col']  = '10';
          metafields[i]['node']['arabic_title']  = 'رمادي حجري - رمادي';
        }else if(pvalue.indexOf("#edede6")>-1){
          metafields[i]['node']['sort_col']  = '9';
          metafields[i]['node']['arabic_title']  = 'أبيض سحابي - ابيض';
        }else if(pvalue.indexOf("#706f48")>-1){
          metafields[i]['node']['sort_col']  = '8';
          metafields[i]['node']['arabic_title']  = 'اخضر كاكي';
        }else if(pvalue.indexOf("#96a480")>-1){
          metafields[i]['node']['sort_col']  = '7';
          metafields[i]['node']['arabic_title']  = 'أخضر فاتح';
        }else if(pvalue.indexOf("#af9483")>-1){
          metafields[i]['node']['sort_col']  = '6';
          metafields[i]['node']['arabic_title']  = 'طوبي - بيج';
        }else if(pvalue.indexOf("#d1332c")>-1){
          metafields[i]['node']['sort_col']  = '5';
          metafields[i]['node']['arabic_title']  = 'احمر شمسي  - برتقالي';
        }else if(pvalue.indexOf("#464f75")>-1){
          metafields[i]['node']['sort_col']  = '4';
          metafields[i]['node']['arabic_title']  = 'أزرق بنفسجي - بنفسج غامق';
        }else if(pvalue.indexOf("#9cc3dc")>-1){
          metafields[i]['node']['sort_col']  = '3';
          metafields[i]['node']['arabic_title']  = 'ازرق محيطي فاتح - لبني فاتح ';
        }else if(pvalue.indexOf("#b9b3d1")>-1){
          metafields[i]['node']['sort_col']  = '2';
          metafields[i]['node']['arabic_title']  = 'لافندر فاتح - بنفسج فاتح';
        }else if(pvalue.indexOf("#f7c8c2")>-1){
          metafields[i]['node']['sort_col']  = '1';
          metafields[i]['node']['arabic_title']  = 'وردي فاتح';
        }
      }
      
      metafields.sort(function(a, b){
        return a.node.sort_col - b.node.sort_col
      });
      
      for (var i = 0; i < metafields.length; i++) {
        pkey = metafields[i]['node']['key'];
        pvalue = metafields[i]['node']['value'];
        p_artitle = metafields[i]['node']['arabic_title'];
        
        if (pkey.indexOf("product_color")>-1){
          let arrColor = pvalue.split('|');
  
          if (arrColor.length>1){
            pcolor = arrColor[0];
            phandle = arrColor[1];
          }else{
            pcolor = arrColor[0];
            phandle = '';
          }

          ptitle= '';
          for (var x = 0; x < this.color_description.length; x++) {
            if (this.color_description[x][1].toLowerCase().trim()==pcolor.toLowerCase().trim()){
              ptitle = this.color_description[x][0];
            }
          }
            
          phtml = phtml+`
            <div class="swatch__element">
              <div class="swatch__label">
                <span class="swatch__color swatch__color--black" style="background-color: `+pcolor+`;"></span>
              </div>
              <a href="javascript: void(0)" onclick="uf_swatchColor(this)" data-url="`+phandle+`" data-main-product-id="`+this.mainproductid+`" class="swatch__link swatch__image" title="`+p_artitle+`">`+phandle+`</a>
            </div>
      `;
        }

      }
      
      if (phtml!=''){
        phtml = `
        <div class="product-block__swatch swatch--circle">
        <div class="custom_product_color">
        `+phtml+`
        </div>
        </div>
        `;
      
      }
      
      this.template = phtml;
    }
  },        
  template: `<div v-html="this.template"></div>`
}
/**COMPNENT FOR COLOR END**/
  
const SearchPageOptions = {
    name: 'Search Page',
    data(){
      return {
        searchTerm: 'Shoes',
        items: [],
        maint_result: [],
        search_filter: [],
        size_filter: [],
        price_filter: [],
        color_filter: [],
        search_result_maxid: 0,
        search_result_maxlength: 0,
        groupings: [],
        showGroupings : true,
        showBundleBanner : false,
        showB1G1Banner: false,       
        selected_group: 'group_all',
        loading: true,
        minAngle: 0,
        maxAngle: 1000,
        defaultMaxPrice: 1000,
        defaultMinPrice: 0,
        price_filter_id: '',
        total_records: 0,
        show_selected_filters: false,
        show_gender_filter: false,
        show_no_result: false,
        
        mobile_product_size: [],
        mobile_product_title: '',
        mobile_product_image: '',
        mobile_product_price: '',
        mobile_product_selected_variant: ''
        
      }
    },
    mounted() {

    },
    created() {
      collection = window._usf_collection_handle;
      search_query = window._usf_query;
      
      console.log(search_query);
      
      if (collection.indexOf("kids")>-1){
        this.show_gender_filter = true;
      }
          
      if (collection!==''&&collection!='all'){
        this.search_filter.push({'id':'111_collection','type':'collection','label':collection});
        let queryString = JSON.stringify(this.search_filter)
        let queryString_encoded = encodeURI(queryString);
      }else{
        if (search_query!=null&&search_query!=''){
          this.search_filter.push({'id':'111_seach_query','type':'squery','label':search_query});
        }else{
          this.search('');
        }
      }
      this.showfilters();
      
      var loaded = false; 
      window.onscroll = () => {
        var top_of_element = $(".usf-btn-loadmore").offset().top;
        var bottom_of_element = $(".usf-btn-loadmore").offset().top + $(".usf-btn-loadmore").outerHeight();
        var bottom_of_screen = $(window).scrollTop() + $(window).innerHeight();
        var top_of_screen = $(window).scrollTop();

        if ((bottom_of_screen > top_of_element) && (top_of_screen < bottom_of_element)){
          if (loaded==false){
            loaded = true;
            //console.log('1');
            this.search_load_more();
          }
        } else {
          loaded = false;
          //console.log('2');
        }  
      }
    },
    watch: {
      search_filter: { 
        handler(val,oldval) {
          let queryString = JSON.stringify(this.search_filter)
          let queryString_encoded = encodeURI(queryString);
          this.search(queryString_encoded);
      this.showfilters(); 
          
          //Refresh Currency Display
          setTimeout(function() {
            $("[name=doubly-currencies]").trigger('change');   
          }, 500)
        
        },
        deep: true
      }
    },
    computed: {
      sliderMin: {
        get: function() {
          var val = parseInt(this.minAngle);
          return this.compute_currency(val);
        },
        set: function(val) {
          val = parseInt(val);
          if (val > this.maxAngle) {
            this.maxAngle = val;
          }
          this.minAngle = val;

          var currency = $("#currency_value").attr('doubly-currency');
          if (currency==''){
          currency = 'SAR';
          }
          
          if (this.maxAngle == this.defaultMaxPrice && this.minAngle == this.defaultMinPrice){
            let index = this.search_filter.map((el) => el.id).indexOf(this.price_filter_id);
            if (index > -1) {
              this.search_filter.splice(index, 1);
            }             
          }else{
            let index = this.search_filter.map((el) => el.id).indexOf(this.price_filter_id);
            if (index > -1) {
              let label = this.compute_currency(this.minAngle)+' '+currency+'-'+this.compute_currency(this.maxAngle)+' '+currency
              this.search_filter[index].label = label;
              this.search_filter[index].minprice = this.minAngle;
              this.search_filter[index].maxprice = this.maxAngle;
            }else{ 
              let label = this.compute_currency(this.minAngle)+' '+currency+'-'+this.compute_currency(this.maxAngle)+' '+currency
              this.search_filter.push({'id':this.price_filter_id,'type':'price','minprice':this.minAngle,'maxprice':this.maxAngle,'label':label});
            }
          }

          //Refresh Currency Display
          setTimeout(function() {
            $("[name=doubly-currencies]").trigger('change');   
          }, 1500)
          
        }
      },
      sliderMax: {
        get: function() {
          var val = parseInt(this.maxAngle);
          return this.compute_currency(val);
        },
        set: function(val) {
          val = parseInt(val);
          if (val < this.minAngle) {
            this.minAngle = val;
          }
          this.maxAngle = val;

          var currency = $("#currency_value").attr('doubly-currency');
          if (currency==''){
          currency = 'SAR';
          }
          
          if (this.maxAngle == this.defaultMaxPrice && this.minAngle == this.defaultMinPrice){
            let index = this.search_filter.map((el) => el.id).indexOf(this.price_filter_id);
            if (index > -1) {
              this.search_filter.splice(index, 1);
            }             
          }else{
            let index = this.search_filter.map((el) => el.id).indexOf(this.price_filter_id);
            if (index > -1) {
              let label = this.compute_currency(this.minAngle)+' '+currency+'-'+this.compute_currency(this.maxAngle)+' '+currency
              this.search_filter[index].label = label;
              this.search_filter[index].minprice = this.minAngle;
              this.search_filter[index].maxprice = this.maxAngle;
            }else{ 
              let label = this.compute_currency(this.minAngle)+' '+currency+'-'+this.compute_currency(this.maxAngle)+' '+currency
              this.search_filter.push({'id':this.price_filter_id,'type':'price','minprice':this.minAngle,'maxprice':this.maxAngle,'label':label});
            }
          }

          //Refresh Currency Display
          setTimeout(function() {
            $("[name=doubly-currencies]").trigger('change');   
          }, 1500)
        }
      }
    },
  methods: {
    showfilters(){
      let show_filter = false;
      for (var x = 0; x < this.search_filter.length; x++) {
        filter =  this.search_filter[x]['type'];
        if (filter=='price'||filter=='color'||filter=='size'||filter=='gender'||filter=='squery'){
          show_filter = true;
          break;
        } 
      }
      this.show_selected_filters = show_filter;
    },
    compute_currency(val){
      currency_value = $("#currency_value").html();
      var numb = currency_value.match(/\d/g);
      numb = numb.join("");          

      if (numb!=''){
        numb = numb/10;
      }else{
        numb = 1;
      }  

      return Math.round(val*numb);
    },
    search_group(group){
      let index = this.search_filter.map((el) => el.type).indexOf('group');
      if (index > -1) {
        this.search_filter.splice(index, 1);
      }             

      this.selected_group = '';
      if (group!='group_all' && group!=''){
        this.search_filter.push({'id':'111_group','type':'group','css_group':group});
      }
      this.selected_group = group;

      let queryString = JSON.stringify(this.search_filter)
      queryString = queryString.replace('&','xxx');

      let queryString_encoded = encodeURI(queryString);

      url_search = 'https://app-sa.glossylounge.com/api/search/?query='+queryString_encoded;
      fetch(url_search)
      .then(response=>response.json())
      .then(suggestions=> {
        this.items=suggestions;
      })

    },
    search(term){
      if (term!==''){
        term = term.replace('&','xxx');
        url_group = 'https://app-sa.glossylounge.com/api/grouping/?query='+term;
        url_search = 'https://app-sa.glossylounge.com/api/search/?query='+term;
      }else{
        url_group = 'https://app-sa.glossylounge.com/api/grouping/';
        url_search = 'https://app-sa.glossylounge.com/api/search/';
      }

      fetch(url_group)
      .then(response=>response.json())
      .then(suggestions=> {
        this.groupings=suggestions['groupings'];

        var current_location =  window.location.href;
        current_location = current_location.trim();

        if (this.groupings.length<=2){
           this.showGroupings = false;          
        }
        if (current_location.indexOf("bundles") > -1){
          this.showGroupings = false;
          this.showBundleBanner = true;          
        }
        if (current_location.indexOf("bundle") > -1){
          this.showGroupings = false;
          this.showBundleBanner = true;          
        }

        this.size_filter=suggestions['size_filter'];
        this.price_filter=suggestions['price_filter'];

        if (this.color_filter.length<=0){
          this.color_filter=suggestions['color_filter'];
        }

        for (var i = 0; i < this.groupings.length; i++) {
          if (this.groupings[i]['group_label'].indexOf("hoodies & sweatshirts")>-1){
            this.groupings[i]['group_ar_label'] = 'هوديز وسويت شيرتات';
          }else if (this.groupings[i]['group_label'].indexOf("leggings")>-1){
            this.groupings[i]['group_ar_label'] = 'ليقنز';
          }else if (this.groupings[i]['group_label'].indexOf("shorts")>-1){
            this.groupings[i]['group_ar_label'] = 'شورتات';
          }else if (this.groupings[i]['group_label'].indexOf("sweatpants & joggers")>-1){
            this.groupings[i]['group_ar_label'] = 'بناطيل و جوقرز';
          }else if (this.groupings[i]['group_label'].indexOf("t shirts & tops")>-1){
            this.groupings[i]['group_ar_label'] = 'تيشيرتات و توبات';
          }else if (this.groupings[i]['group_label'].indexOf("sports bra")>-1){
            this.groupings[i]['group_ar_label'] = 'حمالات صدر رياضية';
          }else if (this.groupings[i]['group_label'].indexOf("underwear")>-1){
            this.groupings[i]['group_ar_label'] = 'ملابس داخلية';
          }else if (this.groupings[i]['group_label'].indexOf("hoodies")>-1){
            this.groupings[i]['group_ar_label'] = 'هوديز';
          }else if (this.groupings[i]['group_label'].indexOf("jumpers")>-1){
            this.groupings[i]['group_ar_label'] = 'بلوفرات';
          }else if (this.groupings[i]['group_label'].indexOf("joggers")>-1){
            this.groupings[i]['group_ar_label'] = 'بناطيل جوقرز';
          }else if (this.groupings[i]['group_label'].indexOf("inners")>-1){
            this.groupings[i]['group_ar_label'] = 'توب داخلي';
          }else if (this.groupings[i]['group_label'].indexOf("crop tops")>-1){
            this.groupings[i]['group_ar_label'] = 'توب قصير (قروب توب)';
          }else if (this.groupings[i]['group_label'].indexOf("long sleeves")>-1){
            this.groupings[i]['group_ar_label'] = 'أكمام طويلة';
          }else if (this.groupings[i]['group_label'].indexOf("short sleeves")>-1){
            this.groupings[i]['group_ar_label'] = 'أكمام قصيرة';
          }else if (this.groupings[i]['group_label'].indexOf("bodysuits")>-1){
            this.groupings[i]['group_ar_label'] = 'بودي سوت';
          }else if (this.groupings[i]['group_label'].indexOf("briefs")>-1){
            this.groupings[i]['group_ar_label'] = 'سراويل داخلية ';
          }else if (this.groupings[i]['group_label'].indexOf("thongs")>-1){
            this.groupings[i]['group_ar_label'] = 'سراويل داخلية نحيفة';
          }else if (this.groupings[i]['group_label'].indexOf("bras")>-1){
            this.groupings[i]['group_ar_label'] = 'حمالات الصدر';
          }else if (this.groupings[i]['group_label'].indexOf("t shirts")>-1){
            this.groupings[i]['group_ar_label'] = 'تي شيرتات';
          }else if (this.groupings[i]['group_label'].indexOf("all")>-1){
            this.groupings[i]['group_ar_label'] = 'الكل';
          }else if (this.groupings[i]['group_label'].indexOf("kids bundles")>-1){
            this.groupings[i]['group_ar_label'] = 'تخفيضات أطقم الأطفال';            
          }else{
            this.groupings[i]['group_ar_label'] = this.groupings[i]['group_label'];
          }
        }

        for (var i = 0; i < this.color_filter.length; i++) {

          if (this.color_filter[i]['hex'].indexOf("#ce879f")>-1){
            this.color_filter[i]['ar_title'] = "روز الكشمير";
          }else if (this.color_filter[i]['hex'].indexOf("#bfbdbb")>-1){
            this.color_filter[i]['ar_title'] = 'حب الفلفل';
          }else if (this.color_filter[i]['hex'].indexOf("#751922")>-1){
            this.color_filter[i]['ar_title'] = 'ريو الأحمر';
          }else if (this.color_filter[i]['hex'].indexOf("#706F48")>-1){
            this.color_filter[i]['ar_title'] = 'قهوة تركية';
          }else if (this.color_filter[i]['hex'].indexOf("#4d2e19")>-1){
            this.color_filter[i]['ar_title'] = 'أرض مظلمة';
          }else if (this.color_filter[i]['hex'].indexOf("#751921")>-1){
            this.color_filter[i]['ar_title'] = 'المهرج الأحمر';
          }else if (this.color_filter[i]['hex'].indexOf("#3e4071")>-1){
            this.color_filter[i]['ar_title'] = 'ازرق غامق';
          }else if (this.color_filter[i]['hex'].indexOf("#383e4e")>-1){
            this.color_filter[i]['ar_title'] = 'أسود فحمي - أسود';
          }else if (this.color_filter[i]['hex'].indexOf("#706f48")>-1){
            this.color_filter[i]['ar_title'] = 'اخضر كاكي';
          }else if (this.color_filter[i]['hex'].indexOf("#af9483")>-1){
            this.color_filter[i]['ar_title'] = 'طوبي - بيج';
          }else if (this.color_filter[i]['hex'].indexOf("#9cc3dc")>-1){
            this.color_filter[i]['ar_title'] = 'ازرق محيطي فاتح - لبني فاتح ';
          }else if (this.color_filter[i]['hex'].indexOf("#b9b3d1")>-1){
            this.color_filter[i]['ar_title'] = 'لافندر فاتح - بنفسج فاتح';
          }else if (this.color_filter[i]['hex'].indexOf("#f7c8c2")>-1){
            this.color_filter[i]['ar_title'] = 'وردي فاتح';
          }else if (this.color_filter[i]['hex'].indexOf("#96a480")>-1){
            this.color_filter[i]['ar_title'] = 'أخضر فاتح';
          }else if (this.color_filter[i]['hex'].indexOf("#939597")>-1){
            this.color_filter[i]['ar_title'] = 'رمادي حجري - رمادي';
          }else if (this.color_filter[i]['hex'].indexOf("#d1332c")>-1){
            this.color_filter[i]['ar_title'] = 'احمر شمسي  - برتقالي';
          }else if (this.color_filter[i]['hex'].indexOf("#464f75")>-1){
            this.color_filter[i]['ar_title'] = 'أزرق بنفسجي - بنفسج غامق';
          }else if (this.color_filter[i]['hex'].indexOf("#edede6")>-1){
            this.color_filter[i]['ar_title'] = 'أبيض سحابي - ابيض';
          }else if (this.color_filter[i]['hex'].indexOf("#3e4071")>-1){
            this.color_filter[i]['ar_title'] = 'ازرق غامق';
          }else if (this.color_filter[i]['hex'].indexOf("#751921")>-1){
            this.color_filter[i]['ar_title'] = 'المهرج الأحمر';
          }else if (this.color_filter[i]['hex'].indexOf("#751922")>-1){
            this.color_filter[i]['ar_title'] = 'ريو الأحمر';
          }
        }
          console.log("CL:",this.color_filter)

        for (var i = 0; i < this.groupings.length; i++) {
          group = this.groupings[i]['css_group'];
          if (group=='group_all'){
            this.total_records = this.groupings[i]['count'];
          }
        }
      })

      fetch(url_search)
      .then(response=>response.json())
      .then(suggestions=> {
        this.main_result=suggestions;
        current_url = window.location.href;

        let x = 1;
        for (var i = 0; i < this.main_result.length; i++) {
          this.main_result[i]['ctr'] = x 
          x = x+1;

          variants = JSON.parse(this.main_result[i]['variants']);
          if (variants[0]['node']['compareAtPrice']!==undefined){
            this.main_result[i]['compareAtPrice'] = variants[0]['node']['compareAtPrice']

            minus_price = this.main_result[i]['compareAtPrice'] - this.main_result[i]['maxprice'];
            divide_price = minus_price / this.main_result[i]['compareAtPrice'];
            percentage_discount = Math.round(divide_price * 100);

            if (percentage_discount>=10 && percentage_discount <=19){
              this.main_result[i]['compareDiscount'] = '20% OFF';            
            }else if (percentage_discount>=20 && percentage_discount <=29){
              this.main_result[i]['compareDiscount'] = '20% OFF';            
            }else if (percentage_discount>=30 && percentage_discount <=39){
              this.main_result[i]['compareDiscount'] = '30% OFF';            
            }else if (percentage_discount>=40 && percentage_discount <=49){
              this.main_result[i]['compareDiscount'] = '40% OFF';            
            }else if (percentage_discount>=50 && percentage_discount <=59){
              this.main_result[i]['compareDiscount'] = '50% OFF';            
            }else {
              this.main_result[i]['compareDiscount'] = '';             
            }

            if (this.main_result[i]['title'].toLowerCase().indexOf('set')>-1){
              this.main_result[i]['compareDiscount'] = '70% OFF';                         
            }else if (this.main_result[i]['handle'].toLowerCase().indexOf('set')>-1){
              this.main_result[i]['compareDiscount'] = '70% OFF';
            }else if (this.main_result[i]['title'].toLowerCase().indexOf('طقم')>-1){
              this.main_result[i]['compareDiscount'] = '70% OFF';
            }else{
              this.main_result[i]['compareDiscount'] = '70% OFF';                         
            }

            if (current_url.indexOf("buy-one-get-one") > -1){
              this.main_result[i]['compareDiscount'] = '';      
              this.showB1G1Banner = true;
            }           
            
          }else{
            this.main_result[i]['compareAtPrice'] = '';
            this.main_result[i]['compareDiscount'] = '';
          }
          
          
          //arabic translation start
          title = this.main_result[i]['title'].toLowerCase().trim(); 
          title = title.replace("'", "");

          arabic_title = this.main_result[i]['title'];
          this.main_result[i]['arabic_title'] = arabic_title 
          //arabic translation end
        }              
        
        let final_result = [];

        //pagination
        if (this.main_result.length>=20){
          this.search_result_maxlength = 20;
        }else{
          this.search_result_maxlength = this.main_result.length;
        }

        for (var i = 0; i < this.search_result_maxlength; i++) {
          final_result.push(this.main_result[i]) 
        }              

        this.items = final_result;

        if (this.main_result.length==0){
          this.show_no_result = true;
        }  

        if (this.main_result.length>20){
          console.log('1')
          $('.usf-btn-loadmore').show();
        }else{
          console.log('2')
          $('.usf-btn-loadmore').hide();
        }
      })
    },
    search_load_more(){
      //pagination
      let start_index = this.search_result_maxlength;
      this.search_result_maxlength = this.search_result_maxlength+20;

      if (this.search_result_maxlength >= this.main_result.length){
        this.search_result_maxlength = this.main_result.length;
        $('.usf-btn-loadmore').hide();
      }

      let result = [];
      for (var i = start_index; i < this.search_result_maxlength; i++) {
        result.push(this.main_result[i]) 
      }              

      let prev_result = JSON.stringify(this.items); 
      prev_result = JSON.parse(prev_result);     
      let final_result = prev_result.concat(result);
      this.items = final_result;

      //Refresh Currency Display
      setTimeout(function() {
        $("[name=doubly-currencies]").trigger('change');   
      }, 500)

    },
    uf_showfiter(filter){

      if ($('.detail-'+filter).css('display') == 'none'){
        $(".arrow-"+filter).addClass('down');
        $(".arrow-"+filter).removeClass('up');          
        $('.detail-'+filter).show();
      }else{
        $(".arrow-"+filter).removeClass('down');
        $(".arrow-"+filter).addClass('up');          
        $('.detail-'+filter).hide();
      }


    },
    uf_remove_filter(type,id,label){
      let index = this.search_filter.map((el) => el.id).indexOf(id);
      if (index > -1) {
        this.search_filter.splice(index, 1);
        if (type=='price'){
          this.minAngle = this.defaultMinPrice;
          this.maxAngle = this.defaultMaxPrice;
        }
        if (type=='size'){
          $("#size_"+id).prop("checked",false);
          $('#size_mobile_' + id).removeClass("oos")
          console.log('#size_mobile_' + id);
        }
        if (type=='color'){
          $("#color_"+id).prop("checked",false);
          $('#color_mobile_' + id).removeClass("color_selected")
        }
        if (type=='gender'){
          $('.mgender').removeClass("oos")
          $('#mobile_gender1').addClass("oos")
        }
      }            
    },
    uf_add_size_filter(id,size){
      if ($('#size_' + id).is(":checked")){
        $('#size_mobile_' + id).addClass("oos")
        this.search_filter.push({'id':id,'type':'size','label':size});
      }else{
        let index = this.search_filter.map((el) => el.id).indexOf(id);
        if (index > -1) {
          $('#size_mobile_' + id).removeClass("oos")
          this.search_filter.splice(index, 1);
        }             
      } 
    },
    uf_add_size_mobile_filter(id,size){
      if (!$('#size_mobile_' + id).hasClass("oos")){
        $("#size_"+id).prop("checked",true);
        $('#size_mobile_' + id).addClass("oos")
        this.search_filter.push({'id':id,'type':'size','label':size});
      }else{
        let index = this.search_filter.map((el) => el.id).indexOf(id);
        if (index > -1) {
          $("#size_"+id).prop("checked",false);
          $('#size_mobile_' + id).removeClass("oos")
          this.search_filter.splice(index, 1);
        }             
      } 
    },
    uf_add_gender_mobile_filter(id,gender,obj_id){
      if (gender=='all'){
        let index = this.search_filter.map((el) => el.id).indexOf(id);
        if (index > -1) {
          this.search_filter.splice(index, 1);
        }             
      }else{
        let index = this.search_filter.map((el) => el.id).indexOf(id);
        if (index > -1) {
          this.search_filter[index]['label'] = gender;
        }else{
          this.search_filter.push({'id':'111_gender','type':'gender','label':gender});
        }
      }

      $('.mgender').removeClass("oos")
      $('#mobile_gender' + obj_id).addClass("oos")
    },
    uf_add_color_filter(id,color){

      if (color=="Jet Black"){
        label_arabic = "أسود فحمي - أسود";
      }else if (color=="Leafy Khaki") {
        label_arabic = "اخضر كاكي";
      }else if (color=="Natural Taupe") {
        label_arabic = "طوبي - بيج";
      }else if (color=="Ocean Pale Blue") {
        label_arabic = "ازرق محيطي فاتح - لبني فاتح ";
      }else if (color=="Pastel Lavender") {
        label_arabic = "لافندر فاتح - بنفسج فاتح";
      }else if (color=="Pastel Pink") {
        label_arabic = "وردي فاتح";
      }else if (color=="Sea Sage Green") {
        label_arabic = "أخضر فاتح";
      }else if (color=="Stone Grey") {
        label_arabic = "رمادي حجري - رمادي";
      }else if (color=="Sunset Red") {
        label_arabic = "احمر شمسي  - برتقالي";
      }else if (color=="Cherry Red") {
        label_arabic = "احمر شمسي  - برتقالي";
      }else if (color=="Violet Blue") {
        label_arabic = "أزرق بنفسجي - بنفسج غامق";
      }else if (color=="White Cloud") {
        label_arabic = "أبيض سحابي - ابيض";
      }else if (color=="Deep Blue") {
        label_arabic = "ازرق غامق";
      }else if (color=="Jester Red") {
        label_arabic = "المهرج الأحمر";
      }else if (color=="Dark Earth") {
        label_arabic = "أرض مظلمة";
      }else if (color=="Turkish Coffee") {
        label_arabic = "قهوة تركية";
      }else if (color=="Rio Red") {
        label_arabic = "ريو الأحمر";
      }else if (color=="Peppercorn") {
        label_arabic = "حب الفلفل";
      }else if (color=="Cashmere Rose") {
        label_arabic = "روز الكشمير";
      }
    console.log("color",color);
    console.log("label_arabic",label_arabic);
      if ($('#color_'+id).is(":checked")){
        this.search_filter.push({'id':id,'type':'color','label':color,'label_arabic':label_arabic});
      }else{
        let index = this.search_filter.map((el) => el.id).indexOf(id);
        if (index > -1) {
          this.search_filter.splice(index, 1);
        }             
      } 
    },
    uf_add_sort_filter(id,sort){
      let index = this.search_filter.map((el) => el.id).indexOf(id);
      if (index > -1) {
        this.search_filter[index]['label'] = sort;
        console.log(this.search_filter[index]);
      }else{
        this.search_filter.push({'id':'111_sort','type':'sort','label':sort});
      }

    },
    uf_add_gender_filter(id,gender){
      console.log("gender",gender);
      if (gender=="Boy"){
        gender = "ولد";
      }else if (gender=="Girl") {
        gender = "بنت";
      }
      if (gender=='all'){
        let index = this.search_filter.map((el) => el.id).indexOf(id);
        if (index > -1) {
          this.search_filter.splice(index, 1);
        }             
      }else{
        let index = this.search_filter.map((el) => el.id).indexOf(id);
        if (index > -1) {
          this.search_filter[index]['label'] = gender;
        }else{
          this.search_filter.push({'id':'111_gender','type':'gender','label':gender});
        }
      }
      $('#gfirstoption').removeClass("ckchecked")
    },
    uf_add_color_mobile_filter(id,color){
      if (!$('#color_mobile_' + id).hasClass("color_selected")){
        $("#color_"+id).prop("checked",true);
        $('#color_mobile_' + id).addClass("color_selected")
        this.search_filter.push({'id':id,'type':'color','label':color});
      }else{
        let index = this.search_filter.map((el) => el.id).indexOf(id);
        if (index > -1) {
          $("#color_"+id).prop("checked",false);
          $('#color_mobile_' + id).removeClass("color_selected")
          this.search_filter.splice(index, 1);
        }             
      } 
    },
    uf_get_max_id(obj){
      return (Math.max.apply(Math, obj.map(function(o) {
        return o.id;
      })) + 0);
    },
    uf_test: function(obj){
      console.log(obj);
    },
    uf_mobile_size_menu: function(obj){
      mp_title = $('#mp_title'+obj.product_id).val();
      $('#mp_variant_id_selected').val('');
      $('#btn-mobile-add').html('SELECT A SIZE');   
      $('#btn-mobile-add').removeClass('add_selected'); 

      if (mp_title!=''){
        return;
      }

      let variants = JSON.parse(obj.variants);
      let processed_variants = [];
      let default_variant_id = '';  

      for (var i = 0; i < variants.length; i++) {
        id = variants[i]['node']['id'];
        title = variants[i]['node']['title'];
        availableForSale = variants[i]['node']['availableForSale'];
        price = variants[i]['node']['price'];

        if (availableForSale){
          if (title=='Default Title'){
            default_variant_id = id;
          }
        }

        let arr_title = title.split('/');
        if (arr_title[0].length <= 6) {
          processed_variants.push({'id':id,'title':arr_title[0],'availableForSale':availableForSale,'price':price});
        }
      } 

      $('#mp_id').val(obj.product_id);
      $('#mp_default_variant'+obj.product_id).val(default_variant_id);
      $('#mp_title'+obj.product_id).val(obj.title);
      $('#mp_image'+obj.product_id).val(obj.featured_image);
      $('#mp_price'+obj.product_id).val(obj.maxprice);
      $('#mp_size'+obj.product_id).val(JSON.stringify(processed_variants));
    },
    in_array: function (needle,haystack){
      let return_value = false;
      for (var i = 0; i < haystack.length; i++) {
        if (haystack[i]['type']==needle){
          return_value = true;
        }else{
          return_value = false;
        }
      }
      return return_value;
    },
    handleScroll: function() {
      console.log('xxx');
    },
    uf_mouseover: function(product_id) {
      image1 = $('.product_image1_'+product_id).val();
      var imageBack = $('.product_image2_'+product_id).val();
      var bg_link = 'url('+imageBack+')';

      $('.product-block__image.product_' +product_id).css({"background": bg_link, "background-size":"cover", "background-position":"50%"});

    },  
    uf_mouseleave: function(product_id) {
      image2 = $('.product_image2_'+product_id).val();
      var image1 = $('.product_image1_'+product_id).val();
      var bg_link = 'url('+image1+')';

      $('.product-block__image.product_' +product_id).css({"background": bg_link, "background-size":"cover", "background-position":"50%"});
    }
  },
  components: {
    'usf-render-color': RenderColor,
    'usf-render-size': RenderSize
  } 
}

const SearchPage = Vue.createApp(SearchPageOptions).mount('#usf_container');

$( ".usf-filter-item" ).mouseleave(function() {
      $(".arrow").removeClass('down');
      $(".arrow").addClass('up'); 
      $('.usf-detail').hide();
});


$( document ).ready(function() {
  
  $( ".usf-facet" ).click(function() {
    $(".usf-facet").addClass( "usf-collapsed" );
    $( this ).removeClass( "usf-collapsed" );
  });
  
  $(document).find('.usf-filter-item').removeClass('active');
  
  $( ".usf-filter-item" ).on('mouseup',function() {
      
    if( $( ".usf-filter-item" ).hasClass('active')){
      $(this).toggleClass("active");

//         setTimeout(function() {
//           $(document).find('.usf-detail').hide();
//         }, 10);
    }
  });


  
});
